import React, { useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';

function AddPaymentPopup({ addPaymentArr, setAddPaymentArr, closePopup }) {
  const [description, setDescription] = useState('');
  const [charges, setCharges] = useState('');

  const handleTemplateSave = () => {
    if (description !== '') {
      if (charges !== '') {
        const updatedData = { ...addPaymentArr, [description]: charges };
        setAddPaymentArr(updatedData);
        setUiMessage('suc', 'Template saved successfully!');
        setDescription('');
        setCharges('');
      } else {
        setUiMessage('war', 'Charges is empty!');
      }
    } else {
      setUiMessage('war', 'Description is empty!');
    }
  };

  return (
    // <div
    //   className="Charge-captre-add-provdr-main hide"
    //   id="addPrvdrcharge"
    //   style={{ display: 'block', marginTop: '-80.4375px', marginRight: 95 }}
    // >
    //   <span className="chatge-hdng">Add payment/ Adjustment code:</span>
    //   <span className="chatge-close-tmplt-nw" onChange={closePopup}>
    //     X
    //   </span>
    //   <div className="Charge-captre-add-provdr-bdy">
    //     <div className="captre-add-provdr-row">
    //       <span className="label">Code:</span>
    //       <span className="value">
    //         <input
    //           className="value-inpt"
    //           id="code"
    //           type="text"
    //           placeholder="Code"
    //           defaultValue=""
    //           maxLength={15}
    //         />
    //       </span>
    //     </div>
    //     <div className="captre-add-provdr-row">
    //       <span className="label">Description:</span>
    //       <span className="value">
    //         <input
    //           className="value-inpt"
    //           id="description"
    //           type="text"
    //           placeholder="Description"
    //           defaultValue=""
    //           maxLength={50}
    //         />
    //       </span>
    //     </div>
    //     <div className="captre-add-provdr-row">
    //       <span className="label">Charges:</span>
    //       <span className="value">
    //         <input
    //           className="value-inpt"
    //           id="adjCharges"
    //           type="text"
    //           placeholder="Charges"
    //           defaultValue=""
    //           maxLength={15}
    //         />
    //       </span>
    //     </div>
    //   </div>
    //   <div className="aptre-add-provdr-btn-row">
    //     <div id="chargAddprvdrCancl" className="button-cancel right">
    //       Cancel
    //     </div>
    //     <div id="addAdjustmentCode" className="button-submit right clear-right">
    //       Add
    //     </div>
    //   </div>
    // </div>
    <div className="modalBackground">
      <div className="compose-msg-main-con grid-sec tab-bg ">
        <div className="comp-msg-hdr flex-sec">
          Add payment/ Adjustment code:
        </div>
        <div className="comp-msg-bdy grid-sec">
          <div
            className="comp-msg-bdy-rw grid-sec"
            style={{ position: 'relative' }}
          >
            <div className="comp-msg-bdy-chld-rw flex-sec">
              <span className="msg-bdy-rw-bl">Description:</span>
              <span className="msg-bdy-rw-val">
                <input
                  type="text"
                  className="msg-inpt"
                  placeholder="Description"
                  // onChange={handleTempSearch}
                  //   style={{ width: '92%' }}
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
                {/* <span className="add-nw-tmplt" onClick={handleTemplateSave}>
                  +
                </span> */}
              </span>
            </div>
            {/* <div className="comp-msg-bdy-chld-rw flex-se ">
                    <div className="search-user-pnl grid-sec">
                        {searchTemplates
                        ? searchTemplates.map((idx) => {
                            return (
                                <span
                                onClick={() => handleMsg(idx)}
                                key={idx}
                                className="usr-name"
                                >
                                {idx}
                                </span>
                            );
                            })
                        : ''}
                    </div>
                </div> */}
          </div>
          <div className="comp-msg-bdy-rw flex-sec">
            <span className="msg-bdy-rw-bl">Charges:</span>
            <span className="msg-bdy-rw-val">
              <textarea
                className="msg-bdy"
                placeholder="Charges"
                onChange={(e) => setCharges(e.target.value)}
                // onFocus={() => setSearchTemplates('')}
                value={charges}
              ></textarea>
            </span>
          </div>
        </div>
        <div className="comp-msg-ftr flex-sec">
          <button className="actn-yes" onClick={handleTemplateSave}>
            Save
          </button>
          <button className="actn-No" onClick={closePopup}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddPaymentPopup;
